import { makeStyles } from '@material-ui/core/styles';
import { baseMenuPaperStyles, menuStyles } from '../Menu/Menu.styles';
export const useSplitButtonStyles = makeStyles({
    buttonGroup: {
        '& .MuiButtonGroup-groupedContainedHorizontal:not(:last-child)': {
            borderRight: '0px'
        },
        '& .MuiButtonGroup-groupedContainedHorizontal:focus-within': {
            boxShadow: 'none'
        }
    },
    toggleBtn: {
        padding: 0,
        minWidth: 32
    },
    popperZIndex: {
        zIndex: 1
    },
    paper: baseMenuPaperStyles,
    menuList: menuStyles
});
